import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SearchVariantPacksForBusinessOrganizationDocument = gql`
  query SearchVariantPacksForBusinessOrganization($query: String!) {
    searchVariantPacksForBusinessOrganization(query: $query) {
      variant_pack_id
    }
  }
`;
export function useSearchVariantPacksForBusinessOrganizationQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SearchVariantPacksForBusinessOrganizationQuery,
    Types.SearchVariantPacksForBusinessOrganizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SearchVariantPacksForBusinessOrganizationQuery,
    Types.SearchVariantPacksForBusinessOrganizationQueryVariables
  >(SearchVariantPacksForBusinessOrganizationDocument, options);
}
export function useSearchVariantPacksForBusinessOrganizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SearchVariantPacksForBusinessOrganizationQuery,
    Types.SearchVariantPacksForBusinessOrganizationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SearchVariantPacksForBusinessOrganizationQuery,
    Types.SearchVariantPacksForBusinessOrganizationQueryVariables
  >(SearchVariantPacksForBusinessOrganizationDocument, options);
}
export type SearchVariantPacksForBusinessOrganizationQueryHookResult =
  ReturnType<typeof useSearchVariantPacksForBusinessOrganizationQuery>;
export type SearchVariantPacksForBusinessOrganizationLazyQueryHookResult =
  ReturnType<typeof useSearchVariantPacksForBusinessOrganizationLazyQuery>;
export type SearchVariantPacksForBusinessOrganizationQueryResult =
  Apollo.QueryResult<
    Types.SearchVariantPacksForBusinessOrganizationQuery,
    Types.SearchVariantPacksForBusinessOrganizationQueryVariables
  >;

/**
 * Wrapped version of useGeneratedSearchVariantPacksForBusinessOrganizationQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSearchVariantPacksForBusinessOrganizationQuery(
  options?: Apollo.QueryHookOptions<
    Types.SearchVariantPacksForBusinessOrganizationQuery,
    Types.SearchVariantPacksForBusinessOrganizationQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SearchVariantPacksForBusinessOrganizationQuery,
    Types.SearchVariantPacksForBusinessOrganizationQueryVariables
  >(SearchVariantPacksForBusinessOrganizationDocument, options);
}

/**
 * Wrapped version of useGeneratedSearchVariantPacksForBusinessOrganizationLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSearchVariantPacksForBusinessOrganizationLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SearchVariantPacksForBusinessOrganizationQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SearchVariantPacksForBusinessOrganizationQuery,
    Types.SearchVariantPacksForBusinessOrganizationQueryVariables
  >(SearchVariantPacksForBusinessOrganizationDocument, lazyOptions);
}
